import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DataGrid, esES } from '@mui/x-data-grid';

const columns = [
    { field: 'id', headerName: 'Top' },
    { field: 'state', headerName: 'Estado', minWidth: 100, flex: 1 },
    { field: 'sales', headerName: 'Compras', minWidth: 100, flex: 1 },
    {
        field: 'total',
        headerName: 'Venta total',
        minWidth: 130,
        flex: 1,
        valueFormatter: ({ value }) => `$${Number(value || 0).toFixed(2)}`
    }
];

const spanishTheme = createTheme(esES);

const StateSalesTable = ({ rows }) => (
    <div style={{ height: 434.5, width: '100%', backgroundColor: '#fff' }}>
        <ThemeProvider theme={spanishTheme}>
            <DataGrid
                style={{ borderRadius: 0 }}
                rows={rows}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                disableSelectionOnClick
            />
        </ThemeProvider>
    </div>
);

export default StateSalesTable;
